var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "createWorkPermit" },
    [
      _c(
        "TMSHeader",
        {
          attrs: {
            title: _vm.title,
            buttons: _vm.buttons,
            needGoback: true,
            extendStickyClass: "createWorkPermit_stickyHeader",
            dotOption: _vm.dotOption,
            helpFunc: _vm.downloadUserGuide,
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "pointer work-permit-status",
              class: _vm.statusStyle,
              attrs: { slot: "status" },
              on: { click: _vm.lifecycleModal },
              slot: "status",
            },
            [
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm._f("customStatusLabel")(_vm.currentWorkPermit.status)
                  )
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _vm.workerInfoLastUpdatedText
            ? _c(
                "i",
                {
                  staticClass: "work-permit-last-updated",
                  attrs: { slot: "status-detail" },
                  slot: "status-detail",
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.workerInfoLastUpdatedText) +
                      "\n    "
                  ),
                ]
              )
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _c("Lifecycle", {
        ref: "workPermitLifecycle",
        attrs: {
          modalId: "work-permit-modules-lifecycle-modal",
          commentAttr: _vm.lifecycleCommentAttrs.comments,
          histories: _vm.histories || [],
          type: "workPermit",
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "createWorkPermit_allInfo" },
        [
          _c(
            "Collapse",
            {
              staticClass: "standalone-detail__collapse",
              attrs: {
                id: "generalInfo",
                title: _vm.$t("workPermit.generalInfo"),
                expand: _vm.expandMap.generalInfo,
                keepContentAlive: true,
              },
              on: { "expand-status": _vm.updateExpandMap },
            },
            [
              _c(
                "div",
                {
                  staticClass: "collapse-padding",
                  attrs: { slot: "content" },
                  slot: "content",
                },
                [
                  _c("GeneralInfo", {
                    key: _vm.currentWorkPermit.updatedAt,
                    ref: "step1_generalInfo",
                    attrs: {
                      isEdit: true,
                      isStandalone: true,
                      isProjectActive: true,
                    },
                  }),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "Collapse",
            {
              staticClass: "standalone-detail__collapse",
              attrs: {
                id: "workerInfo",
                title: _vm.$t("workPermit.workerInfo"),
                expand: _vm.expandMap.workerInfo,
                keepContentAlive: true,
              },
              on: { "expand-status": _vm.updateExpandMap },
            },
            [
              _c(
                "div",
                {
                  staticClass: "collapse-padding",
                  attrs: { slot: "content" },
                  slot: "content",
                },
                [
                  _c("WorkerInfo", {
                    ref: "step2_workerInfo",
                    attrs: { isEdit: true, isStandalone: true },
                  }),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _vm.showHoistingModule
            ? _c(
                "Collapse",
                {
                  staticClass: "standalone-detail__collapse",
                  attrs: {
                    id: "hoisting",
                    title: _vm.hoistingLabel,
                    expand: _vm.expandMap.hoisting,
                    keepContentAlive: true,
                  },
                  on: { "expand-status": _vm.updateExpandMap },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "collapse-padding",
                      attrs: { slot: "content" },
                      slot: "content",
                    },
                    [
                      _c("HoistingHotWork", {
                        ref: "step3_hoistingsInfo",
                        attrs: {
                          isEdit: true,
                          isStandalone: true,
                          isProjectActive: true,
                        },
                      }),
                    ],
                    1
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("ActionConfirmModal", {
        ref: "deleteWorkPermitModal",
        attrs: {
          modalId: "deleteWorkPermitModal_" + _vm.workPermitId,
          confirmTitle: _vm.isRejected
            ? _vm.deleteRejectedWPHint
            : _vm.$t("workPermit.deleteWPConfirmHint"),
        },
      }),
      _vm._v(" "),
      _c(
        "Modal",
        { ref: "tooManyHoistingModal", attrs: { showCloseBtn: false } },
        [
          _c("p", { staticClass: "tooManyHoistingModalMessage" }, [
            _vm._v(
              "\n      " + _vm._s(_vm.workTooManyHoistingMessage) + "\n    "
            ),
          ]),
          _vm._v(" "),
          _c("div", { attrs: { slot: "btns" }, slot: "btns" }, [
            _c(
              "button",
              {
                staticClass: "btn btn--orange",
                attrs: { type: "button" },
                on: { click: _vm.closeTooManyHoistingModal },
              },
              [
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("action.close")) + "\n      "
                ),
              ]
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }